export default __webpack_public_path__ + "static/media/loginSura.69f64b26.png";